{
    "PageTitle": "Tárgyaló/hotdesk foglalás",
    "location": "Válassz helyszínt/termet",
    "date": "Dátum",
    "from_date": "Kezdés dátuma",
    "to_date": "Befejezés dátuma",
    "toDateError": "A 'Befejezés dátuma' legyen ugyanaz vagy későbbi, mint a 'Kezdés dátuma', és a két dátum között max. 30 nap lehet.",
    "topic": "Téma",
    "timeFrom": "Kezdés",
    "timeUntil": "Befejezés",
    "startTime": "Kezdés",
    "capacity": "Hányan lesztek?",
    "btnSubmit": "Küldés",
    "btnReset": "Visszaállít",
    "formReset": "Űrlap visszaállítása",
    "errMsg": "Kérlek, tölts ki minden mezőt!",
    "inputPlaceholder": "írj ide...",
    "hours": "óra",
    "minutes": "perc",
    "starting": "Kezdés",
    "duration": "Időtartam",
    "btnSearch": "Keresés",
    "locationOptionLabel": "Helyszín, terem neve/száma",
    "startOptionLabel": "Válaszd ki a kezdési időt",
    "durationOptionLabel": "Válaszd ki az időtartamot",
    "capacityOptionLabel": "Válaszd ki a létszámot",
    "searchText": "Várj egy pillanatot, próbálunk csatlakozni a szerverhez!",
    "dummyLocationValueOne": "Helyszín 1",
    "dummyLocationValueTwo": "Helyszín 2",
    "roomAvailableTextDummy": "27 szabad helyet találtunk április 24-én 13:00–14:00 között a Hallstadter Straße 119 - Schulungsgebäude",
    "roomAvailableFound": "Megvan",
    "roomAvailableSpaces": "helyek",
    "roomAvailablein": "itt",
    "floorDropdownDummy": " EG Schulungsgebäude",
    "selectedFloorOptionOneDummy": "EG",
    "selectedFloorOptionTwoDummy": "OG",
    "meetingLocationLabel": "Találkozó helye",
    "titleOfMeetingLabel": "Találkozó címe",
    "titleOfMeetingPlaceholder": "Add meg a tervezett találkozó címét vagy témáját",
    "descOfMeetingPlaceholder": "Adj hozzá leírást",
    "meetingDescriptionLabel": "Találkozó leírása (nem kötelező)",
    "availableLabel": "Elérhető",
    "busyLabel": "Foglalt",
    "confirmBookingBtn": "Erősítsd meg a foglalást",
    "bookingSuccessLabel": "Sikerült lefoglalni a termet",
    "bookingFailureLabel": "Valami hiba történt. Próbáld meg később.",
    "selectRoomLocation": "Válassz helyszínt/termet",
    "futureDateError": "Válassz érvényes, jövőbeli dátumot/időt.",
    "noSlotAvailable": "Nincs szabad időpont",
    "tokenRequired": "Hiányzik vagy lejárt a szükséges hozzáférési token.",
    "roomBooked": "A terem már foglalt!",
    "roomPartiallyBooked": "A terem részben foglalt!",
    "participantError": "Te ",
    "participantErrorMsg": " résztvevőre foglalnál, de a terem kapacitása csak ",
    "partiallyFree": "Részben szabad",
    "startingTime": "Kezdés",
    "participants": "Résztvevők száma",
    "max": "Max",
    "capacityLabel": "Férőhely: ",
    "dashboard": "Foglalásaid",
    "manageBookings": "Foglalásaid kezelése",
    "bookAgain": "Foglalj újra",
    "cancelBookingConfrim": "Biztos, hogy törlöd ezt a találkozót?",
    "list": "Lista",
    "search": "Keresés",
    "type": "Típus",
    "updateBookingApiSucessMsg": "Sikeresen frissítetted a foglalást",
    "rebookingApiSucessMsg": "Sikeresen foglaltál",
    "cancelBookingApiSucessMsg": "Sikeresen törölted a foglalást",
    "noUpcomingBooking": "Most nincs közelgő foglalásod",
    "noPastBooking": "Most nincs korábbi foglalásod",
    "apiFailDefaultMsg": "Hoppá, valami hiba történt. Próbáld meg később.",
    "confirm": "Megerősít",
    "cancel": "Mégse",
    "close": "Bezár",
    "fieldRequired": "Töltsd ki ezt a mezőt",
    "selectLocation": "Kérlek, válassz helyszínt",
    "selectDate": "Kérlek, válassz dátumot a foglaláshoz",
    "meetingTitleMissing": "Add meg a találkozó címét",
    "numberOfParticipantMissing": "Add meg a résztvevők számát",
    "gingcoDisclaimer": "A MyHelp megkönnyíti a teremfoglalást. Más Gingco szolgáltatásokért (pl.: Catering Services) keresd a Gingco-t.",
    "availability": {
        "text": "Elérhetőség",
        "free": "Igen, szabad",
        "busy": "Sajnos nem elérhető",
        "busyHint": "Próbáld meg módosítani a dátumot vagy az időpontot, vagy nézd meg a közeli termeket",
        "partialFree": "Részben szabad terem",
        "unknown": "Ismeretlen"
    },
    "manageBooking": {
        "meetingLocation": "Találkozó helye",
        "reschedule": "Időpont módosítása",
        "bookAgain": "Foglalj újra",
        "rescheduleTo": "Átütemezés ide",
        "cancelMeeting": "Találkozó lemondása",
        "searchPlaceholder": "Keress találkozó ID, leírás vagy helyszín alapján"
    },
    "durationOptions": {
        "15 Min": "15 perc",
        "30 Min": "30 perc",
        "45 Min": "45 perc",
        "1 Hr": "1 óra",
        "2 Hr": "2 óra",
        "4 Hr": "4 óra",
        "8 Hr": "8 óra"
    },
    "meetingRoomTypes": {
        "All": "Összes",
        "Hot Desk": "Hot Desk",
        "Meeting Room": "Tárgyaló"
    },
    "peopleCount": "Hányan lesztek?"
}